/**
 * @Description 检查是否可以合同签约的弹窗
 */

import { FC } from 'react';
import { Modal, Button } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
// import cs from 'classnames';
// import styles from './entry.module.less';

interface CheckContractModalProps {
  [p:string]: any;
}
const CheckContractModal:FC<CheckContractModalProps> = ({
  modalData,
  close,
  handleAreaProtection
}) => {
  const { open, data } = modalData || {};
  return (
    <Modal
      title='提示'
      open={open}
      footer={null}
      onCancel={close}>
      <>
        <div>
          <InfoCircleFilled className='color-warning'/>
          <span className='pl-6'>
            {
              data?.includes('360') ? <span>合同签约超过保护期限{data?.includes('361') || data?.includes('362') ? '；' : '，不予提交。'}</span> : <></>
            }
            {
              data?.includes('361') || data?.includes('362') ? <span>周边存在待开/已开门店，不予提交。</span> : <></>
            }
          </span>
        </div>
        {
          /**
     * 合同签约超过保护期限，不予提交。
     */
          // EXCEEDED_PROTECTION_PERIOD("360", "EXCEEDED_PROTECTION_PERIOD", "合同签约超过保护期限，不予提交。", "合同签约超过保护期限，不予提交。", ErrorLevels.WARN, ErrorTypes.BIZ),

          /**
     * 周边存在待开业门店，不予提交。
     */
          // PENDING_STORE_NEARBY("361", "PENDING_STORE_NEARBY", "周边存在待开业门店，不予提交。", "周边存在待开业门店，不予提交。", ErrorLevels.ERROR, ErrorTypes.BIZ),

          /**
     * 周边存在已开业门店，不予提交。
     */
          // OPENED_STORE_NEARBY("362", "OPENED_STORE_NEARBY", "周边存在已开业门店，不予提交。", "周边存在已开业门店，不予提交。", ErrorLevels.ERROR, ErrorTypes.BIZ),
          data?.includes('360') ? <div className='rt mt-32'>
            <Button onClick={close}>取消</Button>
            <Button
              type='primary'
              className='ml-12'
              onClick={handleAreaProtection}
            >申请保护</Button>
          </div> : <div className='mt-32'></div>
        }
      </>
    </Modal>
  );
};

export default CheckContractModal;
